// CloudDocDropdown.jsx - With Reordered Categories
import React from 'react';
import './cloudDocDropdown.scss';

const CloudDocDropdown = ({
   isOpen,
   onClose,
   sub_categoryList,
   history,
   modalpolicyChange,
   modalpolicyCountrychange,
   countriesList,
   movetoContact
}) => {
   if (!isOpen) return null;

   // Icon mapping for service types
   const serviceIconMap = {
      'home-care': 'house.png',
      'children-s-home': 'swing.png',
      'supported-living': 'slhouse.png',
      'supported-accommodation-for-young-people': 'clinic.png',
      'care-home': 'carehome.png',
      'temporary-staffing': 'calender.png'
   };

   // Description mapping for service types
   const serviceDescriptionMap = {
      'home-care': "Policies for personal care at home",
      'children-s-home': "Ofsted-compliant policy sets",
      'supported-living': "Adult support services",
      'supported-accommodation-for-young-people': "Regulated 16+ provision",
      'care-home': 'CQC-ready care home policies',
      'temporary-staffing': 'Care worker agency policies'
   };

   // Display name mapping
   const serviceNameMap = {
      'Home Care': 'Domiciliary Care',
   };

   // Country icon mapping
   const countryIconMap = {
      'england': 'england_flag.png',
      'wales': 'wales.png',
      'scotland': 'scotland.png',
      'northern-ireland': 'wales.png'
   };

   const serviceRouteMap = {
      'home-care': '/policies-procedures?step=3&services=home-care&locations=england',
      'supported-living': '/policies-procedures?step=3&services=supported-living&locations=england',
      'children-s-home': '/policies-procedures?step=3&services=children-s-home&locations=england',
      'care-home': '/policies-procedures?step=3&services=care-home&locations=england',
      'supported-accommodation-for-young-people': '/policies-procedures?step=3&services=supported-accommodation-for-young-people&locations=england',
      'temporary-staffing': '/policies-procedures?step=3&services=temporary-staffing&locations=england',
   };
   // const serviceRouteMap = {
   //    'home-care': '/domiciliary-care-policies',
   //    'supported-living': '/policies-procedures',
   //    'children-s-home': '/policies-procedures',
   //    'care-home': '/policies-procedures',
   //    'supported-accommodation-for-young-people': '/policies-procedures',
   //    'temporary-staffing': '/policies-procedures',
   // };

   // Define the desired order of categories by slug
   const categoryOrder = [
      'home-care',           // 1. Domiciliary Care
      'children-s-home',     // 2. Children's Home
      'supported-living',    // 3. Supported Living
      'care-home',           // 4. Care Home
      'supported-accommodation-for-young-people', // 5. Supported Accommodation
      'temporary-staffing'   // 6. Temporary Staffing
   ];

   // Function to reorder the category list based on defined order
   const getOrderedCategories = (categories) => {
      if (!categories || !Array.isArray(categories)) return [];

      const orderedList = [];

      // First, add items in the specified order
      categoryOrder.forEach(slug => {
         const found = categories.find(cat => cat.slug === slug);
         if (found) {
            orderedList.push(found);
         }
      });

      // Then, add any remaining items that weren't in the order list
      categories.forEach(cat => {
         if (!categoryOrder.includes(cat.slug)) {
            orderedList.push(cat);
         }
      });

      return orderedList;
   };

   // Function to handle service type click with dynamic routing
   const handleServiceClick = (item) => {
      const slug = item.slug;

      // Check if slug has a dedicated route in serviceRouteMap
      if (serviceRouteMap[slug]) {
         history.push(serviceRouteMap[slug]);
         onClose();
         return;
      }

      // Check for partial matches using includes
      // This handles cases where slugs might vary slightly
      const routeKeys = Object.keys(serviceRouteMap);
      for (const key of routeKeys) {
         if (slug.includes(key) || key.includes(slug)) {
            history.push(serviceRouteMap[key]);
            onClose();
            return;
         }
      }

      // Default behavior: use modalpolicyChange for other categories
      modalpolicyChange(slug);
      onClose();
   };

   // Get the ordered categories
   const orderedCategoryList = getOrderedCategories(sub_categoryList);

   console.log({ orderedCategoryList: sub_categoryList });


   return (
      <div className="policy-modal-backdrop" onClick={onClose}>
         <div className="policy-modal-content" onClick={(e) => e.stopPropagation()} onMouseLeave={onClose}>
            <div className="clouddoc-mega-menu">
               <div className="clouddoc-mega-menu__container">
                  <div className="clouddoc-mega-menu__grid">

                     {/* Service Type Column */}
                     <div className="clouddoc-mega-menu__section">
                        <h3 className="clouddoc-mega-menu__section-title">Service Type</h3>
                        <div className="clouddoc-mega-menu__items">
                           {orderedCategoryList.slice(0, 6).map((item) => (
                              <div
                                 className="clouddoc-mega-menu__item"
                                 key={item._id}
                                 // onClick={() => modalpolicyChange(item.slug)}
                                 onClick={() => handleServiceClick(item)}
                              >
                                 <div className="clouddoc-mega-menu__item-icon">
                                    <img
                                       src={
                                          process.env.PUBLIC_URL +
                                          `/assets/images/careDaily/${serviceIconMap[item.slug] ?? 'clinic.png'
                                          }`
                                       }
                                       width="20px"
                                       alt={item.name}
                                    />
                                 </div>
                                 <div className="clouddoc-mega-menu__item-content">
                                    <h4 className="clouddoc-mega-menu__item-title">
                                       {serviceNameMap[item.name] || item.name}
                                    </h4>
                                    <p className="clouddoc-mega-menu__item-description">
                                       {serviceDescriptionMap[item.slug] || '-'}
                                    </p>
                                 </div>
                              </div>
                           ))}
                        </div>
                     </div>

                     {/* Document Management Column */}
                     <div className="clouddoc-mega-menu__section compact">
                        <h3 className="clouddoc-mega-menu__section-title">Document Management</h3>
                        <div className="clouddoc-mega-menu__items">
                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/document-vault')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="3" y="11" width="18" height="10" rx="2" ry="2" />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Document Vault</h4>
                                 <p className="clouddoc-mega-menu__item-description">Secure storage with version control</p>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/smart-editor')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14 2 14 8 20 8" />
                                    <line x1="16" y1="13" x2="8" y2="13" />
                                    <line x1="16" y1="17" x2="8" y2="17" />
                                    <polyline points="10 9 9 9 8 9" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Smart Editor</h4>
                                 <p className="clouddoc-mega-menu__item-description">Edit templates with compliance structure</p>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/compliance-calendar')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Compliance Calendar</h4>
                                 <p className="clouddoc-mega-menu__item-description">Track reviews and renewals</p>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/export-print')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14 2 14 8 20 8" />
                                    <path d="M12 18v-6" />
                                    <path d="m9 15 3 3 3-3" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Export & Print</h4>
                                 <p className="clouddoc-mega-menu__item-description">Generate inspection-ready PDFs</p>
                              </div>
                           </div>
                        </div>

                        {/* Document Features Info Box */}
                        <div className="clouddoc-mega-menu__info-section">
                           <h3 className="clouddoc-mega-menu__section-title">Document Features</h3>
                           <div className="clouddoc-mega-menu__items">
                              <div className="clouddoc-mega-menu__item" onClick={() => history.push('/update-alerts')}>
                                 <div className="clouddoc-mega-menu__item-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                       <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                       <polyline points="22 4 12 14.01 9 11.01" />
                                    </svg>
                                 </div>
                                 <div className="clouddoc-mega-menu__item-content">
                                    <h4 className="clouddoc-mega-menu__item-title">Update Alerts</h4>
                                    <p className="clouddoc-mega-menu__item-description">Automatic regulatory notifications</p>
                                 </div>
                              </div>

                              <div className="clouddoc-mega-menu__item" onClick={() => history.push('/team-access')}>
                                 <div className="clouddoc-mega-menu__item-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                       <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                       <polyline points="22 4 12 14.01 9 11.01" />
                                    </svg>
                                 </div>
                                 <div className="clouddoc-mega-menu__item-content">
                                    <h4 className="clouddoc-mega-menu__item-title">Team Access</h4>
                                    <p className="clouddoc-mega-menu__item-description">Role-based permissions</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     {/* By Country Column */}
                     <div className="clouddoc-mega-menu__section compact">
                        <h3 className="clouddoc-mega-menu__section-title">By Country</h3>
                        <div className="clouddoc-mega-menu__items">
                           <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('england')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/england_flag.png`} width="20px" alt="England" />
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">England</h4>
                                 <p className="clouddoc-mega-menu__item-description">CQC & Ofsted aligned</p>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('wales')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/wales.png`} width="20px" alt="Wales" />
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Wales</h4>
                                 <p className="clouddoc-mega-menu__item-description">CIW compliant</p>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('scotland')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/scotland.png`} width="20px" alt="Scotland" />
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Scotland</h4>
                                 <p className="clouddoc-mega-menu__item-description">Care Inspectorate ready</p>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('northern-ireland')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${countryIconMap['northern-ireland']}`} width="20px" alt="Northern Ireland" />
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">N. Ireland</h4>
                                 <p className="clouddoc-mega-menu__item-description">RQIA standards</p>
                              </div>
                           </div>
                        </div>

                        {/* CTA Box */}
                        <div className="clouddoc-mega-menu__cta-box">
                           <h4 className="clouddoc-mega-menu__cta-title">Need Custom Policies?</h4>
                           <p className="clouddoc-mega-menu__cta-description">Get tailored documents for your specific requirements</p>
                           <button className="clouddoc-mega-menu__cta-button" onClick={movetoContact}>
                              Contact Us
                           </button>
                        </div>
                     </div>

                     {/* Quick Access Column */}
                     <div className="clouddoc-mega-menu__section compact quick-links">
                        <h3 className="clouddoc-mega-menu__section-title">Quick Access</h3>
                        <div className="clouddoc-mega-menu__items">
                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/policies-procedures')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Document Pricing</h4>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/documentlibrary')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="m21 21-4.35-4.35" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Document Search</h4>
                              </div>
                           </div>

                           <div className="clouddoc-mega-menu__item" onClick={() => history.push('/updates')}>
                              <div className="clouddoc-mega-menu__item-icon">
                                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="3" />
                                    <path d="M12 1v6m0 6v6m11-11h-6m-6 0H1" />
                                    <path d="m20.49 15.49-3.66-3.66M3.51 20.49l3.66-3.66M20.49 8.51l-3.66 3.66M3.51 3.51l3.66 3.66" />
                                 </svg>
                              </div>
                              <div className="clouddoc-mega-menu__item-content">
                                 <h4 className="clouddoc-mega-menu__item-title">Update Centre</h4>
                              </div>
                           </div>
                        </div>

                        {/* Compliance Integration Info Box */}
                        {/* <div className="clouddoc-mega-menu__info-section compliance-integration">
                           <h3 className="clouddoc-mega-menu__section-title">Compliance Integration</h3>
                           <div className="clouddoc-mega-menu__items">
                              <div className="clouddoc-mega-menu__item" onClick={() => history.push('/cqc-sync')}>
                                 <div className="clouddoc-mega-menu__item-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                       <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                       <polyline points="22 4 12 14.01 9 11.01" />
                                    </svg>
                                 </div>
                                 <div className="clouddoc-mega-menu__item-content">
                                    <h4 className="clouddoc-mega-menu__item-title">CQC Sync</h4>
                                    <p className="clouddoc-mega-menu__item-description">Direct KLOEs mapping</p>
                                 </div>
                              </div>
                           </div>
                        </div> */}

                        {/* Document Search CTA Card */}
                        <div className="clouddoc-mega-menu__search-cta-card">
                           <div className="search-cta-content">
                              <div className="search-cta-header">
                                 <div className="search-cta-icon">
                                    <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/search.png`} alt="Search" width="16px" />
                                 </div>
                                 <h4 className="search-cta-title">Document Search</h4>
                              </div>
                              <p className="search-cta-text">Find policies and compliance documents instantly</p>
                              <button className="search-cta-btn" onClick={() => history.push('/documentlibrary')}>
                                 <span>Browse Documents</span>
                                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                 </svg>
                              </button>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default CloudDocDropdown;

// CloudDocDropdown.jsx - Redesigned to match MegaMenu style
// import React from 'react';
// import './cloudDocDropdown.scss';


// const CloudDocDropdown = ({
//    isOpen,
//    onClose,
//    sub_categoryList,
//    history,
//    modalpolicyChange,
//    modalpolicyCountrychange,
//    countriesList,
//    movetoContact
// }) => {
//    if (!isOpen) return null;

//    // Icon mapping for service types
//    const serviceIconMap = {
//       'home-care': 'house.png',
//       'children-s-home': 'swing.png',
//       'supported-living': 'slhouse.png',
//       'supported-accommodation-for-young-people': 'clinic.png',
//       'care-home': 'carehome.png',
//       'temporary-staffing': 'calender.png'
//    };

//    // Description mapping for service types
//    const serviceDescriptionMap = {
//       'home-care': "Policies for personal care at home",
//       'children-s-home': "Ofsted-compliant policy sets",
//       'supported-living': "Adult support services",
//       'supported-accommodation-for-young-people': "Unregulated 16+ provision",
//       'care-home': 'CQC-ready care home policies',
//       'temporary-staffing': 'Care worker agency policies'
//    };

//    // Display name mapping
//    const serviceNameMap = {
//       'Home Care': 'Domiciliary Care',
//    };

//    // Country icon mapping
//    const countryIconMap = {
//       'england': 'england_flag.png',
//       'wales': 'wales.png',
//       'scotland': 'scotland.png',
//       'northern-ireland': 'wales.png' // Using wales icon as placeholder
//    };

//    return (
//       <div className="policy-modal-backdrop" onClick={onClose}>
//          <div className="policy-modal-content" onClick={(e) => e.stopPropagation()} onMouseLeave={onClose}>
//             <div className="clouddoc-mega-menu">
//                <div className="clouddoc-mega-menu__container">
//                   <div className="clouddoc-mega-menu__grid">

//                      {/* Service Type Column */}
//                      <div className="clouddoc-mega-menu__section">
//                         <h3 className="clouddoc-mega-menu__section-title">Service Type</h3>
//                         <div className="clouddoc-mega-menu__items">
//                      {sub_categoryList?.slice(0, 6).map((item) => (
//    <div
//       className="clouddoc-mega-menu__item"
//       key={item._id}
//       onClick={() => modalpolicyChange(item.slug)}
//    >
//       <div className="clouddoc-mega-menu__item-icon">
//          <img
//             src={
//                process.env.PUBLIC_URL +
//                `/assets/images/careDaily/${
//                   serviceIconMap[item.slug] ?? 'clinic.png'
//                }`
//             }
//             width="20px"
//             alt={item.name}
//          />
//       </div>
//       <div className="clouddoc-mega-menu__item-content">
//          <h4 className="clouddoc-mega-menu__item-title">
//             {serviceNameMap[item.name] || item.name}
//          </h4>
//          <p className="clouddoc-mega-menu__item-description">
//             {serviceDescriptionMap[item.slug] || item.slug || '-'}
//          </p>
//       </div>
//    </div>
// ))}

//                         </div>
//                      </div>

//                      {/* Document Management Column */}
//                      <div className="clouddoc-mega-menu__section compact">
//                         <h3 className="clouddoc-mega-menu__section-title">Document Management</h3>
//                         <div className="clouddoc-mega-menu__items">
//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/document-vault')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <rect x="3" y="11" width="18" height="10" rx="2" ry="2" />
//                                     <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Document Vault</h4>
//                                  <p className="clouddoc-mega-menu__item-description">Secure storage with version control</p>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/smart-editor')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                                     <polyline points="14 2 14 8 20 8" />
//                                     <line x1="16" y1="13" x2="8" y2="13" />
//                                     <line x1="16" y1="17" x2="8" y2="17" />
//                                     <polyline points="10 9 9 9 8 9" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Smart Editor</h4>
//                                  <p className="clouddoc-mega-menu__item-description">Edit templates with compliance structure</p>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/compliance-calendar')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
//                                     <line x1="16" y1="2" x2="16" y2="6" />
//                                     <line x1="8" y1="2" x2="8" y2="6" />
//                                     <line x1="3" y1="10" x2="21" y2="10" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Compliance Calendar</h4>
//                                  <p className="clouddoc-mega-menu__item-description">Track reviews and renewals</p>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/export-print')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                                     <polyline points="14 2 14 8 20 8" />
//                                     <path d="M12 18v-6" />
//                                     <path d="m9 15 3 3 3-3" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Export & Print</h4>
//                                  <p className="clouddoc-mega-menu__item-description">Generate inspection-ready PDFs</p>
//                               </div>
//                            </div>
//                         </div>

//                         {/* Document Features Info Box */}
//                         <div className="clouddoc-mega-menu__info-section">
//                            <h3 className="clouddoc-mega-menu__section-title">Document Features</h3>
//                            <div className="clouddoc-mega-menu__items">
//                               <div className="clouddoc-mega-menu__item" onClick={() => history.push('/update-alerts')}>
//                                  <div className="clouddoc-mega-menu__item-icon">
//                                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//                                        <polyline points="22 4 12 14.01 9 11.01" />
//                                     </svg>
//                                  </div>
//                                  <div className="clouddoc-mega-menu__item-content">
//                                     <h4 className="clouddoc-mega-menu__item-title">Update Alerts</h4>
//                                     <p className="clouddoc-mega-menu__item-description">Automatic regulatory notifications</p>
//                                  </div>
//                               </div>

//                               <div className="clouddoc-mega-menu__item" onClick={() => history.push('/team-access')}>
//                                  <div className="clouddoc-mega-menu__item-icon">
//                                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//                                        <polyline points="22 4 12 14.01 9 11.01" />
//                                     </svg>
//                                  </div>
//                                  <div className="clouddoc-mega-menu__item-content">
//                                     <h4 className="clouddoc-mega-menu__item-title">Team Access</h4>
//                                     <p className="clouddoc-mega-menu__item-description">Role-based permissions</p>
//                                  </div>
//                               </div>
//                            </div>
//                         </div>
//                      </div>

//                      {/* By Country Column */}
//                      <div className="clouddoc-mega-menu__section compact">
//                         <h3 className="clouddoc-mega-menu__section-title">By Country</h3>
//                         <div className="clouddoc-mega-menu__items">
//                            <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('england')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/england_flag.png`} width="20px" alt="England" />
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">England</h4>
//                                  <p className="clouddoc-mega-menu__item-description">CQC & Ofsted aligned</p>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('wales')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/wales.png`} width="20px" alt="Wales" />
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Wales</h4>
//                                  <p className="clouddoc-mega-menu__item-description">CIW compliant</p>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('scotland')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/scotland.png`} width="20px" alt="Scotland" />
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Scotland</h4>
//                                  <p className="clouddoc-mega-menu__item-description">Care Inspectorate ready</p>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => modalpolicyCountrychange('northern-ireland')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${countryIconMap['northern-ireland']}`} width="20px" alt="Northern Ireland" />
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">N. Ireland</h4>
//                                  <p className="clouddoc-mega-menu__item-description">RQIA standards</p>
//                               </div>
//                            </div>
//                         </div>

//                         {/* CTA Box */}
//                         <div className="clouddoc-mega-menu__cta-box">
//                            <h4 className="clouddoc-mega-menu__cta-title">Need Custom Policies?</h4>
//                            <p className="clouddoc-mega-menu__cta-description">Get tailored documents for your specific requirements</p>
//                            <button
//                               className="clouddoc-mega-menu__cta-button"
//                               onClick={movetoContact}
//                            >
//                               Contact Us
//                            </button>
//                         </div>
//                      </div>

//                      {/* Quick Access Column */}
//                      <div className="clouddoc-mega-menu__section compact quick-links">
//                         <h3 className="clouddoc-mega-menu__section-title">Quick Access</h3>
//                         <div className="clouddoc-mega-menu__items">
//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/policies-procedures')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Document Pricing</h4>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/documentlibrary')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <circle cx="11" cy="11" r="8" />
//                                     <path d="m21 21-4.35-4.35" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Document Search</h4>
//                               </div>
//                            </div>

//                            <div className="clouddoc-mega-menu__item" onClick={() => history.push('/updates')}>
//                               <div className="clouddoc-mega-menu__item-icon">
//                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <circle cx="12" cy="12" r="3" />
//                                     <path d="M12 1v6m0 6v6m11-11h-6m-6 0H1" />
//                                     <path d="m20.49 15.49-3.66-3.66M3.51 20.49l3.66-3.66M20.49 8.51l-3.66 3.66M3.51 3.51l3.66 3.66" />
//                                  </svg>
//                               </div>
//                               <div className="clouddoc-mega-menu__item-content">
//                                  <h4 className="clouddoc-mega-menu__item-title">Update Centre</h4>
//                               </div>
//                            </div>
//                         </div>

//                         {/* Compliance Integration Info Box */}
//                         <div className="clouddoc-mega-menu__info-section compliance-integration">
//                            <h3 className="clouddoc-mega-menu__section-title">Compliance Integration</h3>
//                            <div className="clouddoc-mega-menu__items">
//                               <div className="clouddoc-mega-menu__item" onClick={() => history.push('/cqc-sync')}>
//                                  <div className="clouddoc-mega-menu__item-icon">
//                                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
//                                        <polyline points="22 4 12 14.01 9 11.01" />
//                                     </svg>
//                                  </div>
//                                  <div className="clouddoc-mega-menu__item-content">
//                                     <h4 className="clouddoc-mega-menu__item-title">CQC Sync</h4>
//                                     <p className="clouddoc-mega-menu__item-description">Direct KLOEs mapping</p>
//                                  </div>
//                               </div>
//                            </div>
//                         </div>

//                         {/* Document Search CTA Card */}
//                         <div className="clouddoc-mega-menu__search-cta-card">
//                            <div className="search-cta-content">
//                               <div className="search-cta-header">
//                                  <div className="search-cta-icon">
//                                     <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/search.png`} alt="Search" width="16px" />
//                                  </div>
//                                  <h4 className="search-cta-title">Document Search</h4>
//                               </div>
//                               <p className="search-cta-text">Find policies and compliance documents instantly</p>
//                               <button
//                                  className="search-cta-btn"
//                                  onClick={() => history.push('/documentlibrary')}
//                               >
//                                  <span>Browse Documents</span>
//                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
//                                  </svg>
//                               </button>
//                            </div>
//                         </div>
//                      </div>

//                   </div>
//                </div>
//             </div>
//          </div>
//       </div>
//    );
// };

// export default CloudDocDropdown;
